module.exports = __webpack_public_path__ + "static/media/g6.22e77177.jpeg";